import { SURVEY_CONFIG_FIELDS, SURVEY_FORM_FIELDS } from "../constants";
import ExpirationDate from "./components/ExpirationDate";
import SlugInput from "./components/SlugInput";
import SurveyStatusSelect from "./components/SurveyStatusSelect";
import UnlimitedAnswers from "./components/UnlimitedAnswersCheckbox";
import {
  ConfigContainer,
  Container,
  ContentContainer,
  ErrorContainer,
  ErrorText,
  ErrorTitle,
  Spacer,
  Title,
} from "./styles";

export default function SurveyConfig({
  values = {},
  errorMessage = "",
  onChangeValue = () => null,
}) {
  return (
    <Container>
      <ContentContainer>
        <ConfigContainer>
          <Title>Configuração da pesquisa</Title>
          <Spacer />
          <Spacer />
          <SurveyStatusSelect
            selectedStatus={values[SURVEY_FORM_FIELDS.STATUS]}
            onChangeSelectedStatus={(status) =>
              onChangeValue(SURVEY_FORM_FIELDS.STATUS, status)
            }
          />
          <Spacer />
          <SlugInput
            surveyTitle={values[SURVEY_FORM_FIELDS.TITLE]}
            slug={values[SURVEY_FORM_FIELDS.SLUG]}
            onChangeSlug={(slug) =>
              onChangeValue(SURVEY_FORM_FIELDS.SLUG, slug)
            }
          />
          <Spacer />
          <ExpirationDate
            date={values[SURVEY_FORM_FIELDS.EXPIRES_IN]}
            onChangeDate={(date) =>
              onChangeValue(SURVEY_FORM_FIELDS.EXPIRES_IN, date)
            }
          />
          <UnlimitedAnswers
            hasUnlimitedAnswers={(values[SURVEY_FORM_FIELDS.CONFIG] || {})[SURVEY_CONFIG_FIELDS.HAS_UNLIMITED_ANSWERS]}
            onChangeHasUnlimitedAnswers={value => {
              onChangeValue(SURVEY_FORM_FIELDS.CONFIG, {
                ...value[SURVEY_FORM_FIELDS.CONFIG],
                [SURVEY_CONFIG_FIELDS.HAS_UNLIMITED_ANSWERS]: value
              })
            }}
          />
        </ConfigContainer>
        {!!errorMessage && (
          <ErrorContainer>
            <ErrorTitle>Houve um erro ao enviar a pesquisa, corrija antes de enviar novamente:</ErrorTitle>
            <ErrorText>{errorMessage}</ErrorText>
          </ErrorContainer>
        )}
      </ContentContainer>
    </Container>
  );
}
